module.exports = __webpack_public_path__ + "media/roomBgm.d30bbe5c.mp3";